<template>
  <div id="app">
    <TopNavBar>
    </TopNavBar>
    <router-view></router-view>
  </div>
</template>

<script>

import TopNavBar from "./components/TopNavBar";
export default {
  name: 'App',
  components: {TopNavBar},
  methods: {
  },
  data() {
    return {
    }
  }
}
</script>
